import $ from 'jquery';
import React from 'react';
import {
  inputsValidator,
  setLocalStorage,
  validateField,
  updateSize,
} from '../../../helpers/tools';
import { PD_DESCRIPTION, PD_BANNER_DESCRIPTION } from '../../../constants/Labels';
class PlacementData extends React.Component {
  componentDidMount() {
    updateSize();
    this.toggleBlurListeners(true);
  }

  componentWillUnmount() {
    this.toggleBlurListeners(false);
  }
  /** Used for import settings, to display on active tab errors */
  componentDidUpdate() {
    this.toggleBlurListeners(false);
    this.toggleBlurListeners(true);
  }
  /**
   * Method to check that all fileds from form are valid and we can start test
   */
  updateState = () => {
    let adData = {
      isValid: true,
      sas_format_linears: $('input[name=linearFormatId]').val(),
      sas_format_overlays: $('input[name=nonLinearFormatId]').val(),
      sas_networkid: $('input[name=networkId]').val(),
      sas_pageid: $('input[name=pageId]').val(),
      sas_siteid: $('input[name=siteId]').val(),
      sas_target: $('input[name=targeting]').val(),
    };
    let bannerData = {
      sas_format_banners: $('input[name=bannerFormatId]').val(),
      sas_target_banners: $('input[name=bannerTargeting]').val(),
    };

    $('.settingsInputs .validationError')
      .toArray()
      .forEach(item => {
        if ($(item).is(':visible')) {
          adData.isValid = false;
        }
      });

    if (adData.isValid) {
      setLocalStorage('adData', JSON.stringify(adData));
      let updatedConfiguration = structuredClone(this.props.configuration);
      if (!updatedConfiguration['banner']) {
        updatedConfiguration['banner'] = {
          sas_format_banners: '',
          sas_target_banners: '',
        };
      }
      updatedConfiguration.banner.sas_format_banners = bannerData.sas_format_banners;
      updatedConfiguration.banner.sas_target_banners = bannerData.sas_target_banners;
      setLocalStorage('configuration', JSON.stringify(updatedConfiguration));
    }

    this.props.updateBannerState(bannerData);
    this.props.updateState(adData);
  };

  /**
   * Method to check that at least one of the fields are valid
   * @param {event} event
   * @param {array} connectedFields array of elements where at least one should be filled
   */
  validateFieldWithOther = (event, connectedFields) => {
    const ERROR = 'At least one format ID should be defined';
    let ifTargetIsValid = inputsValidator(event.target.value, false, 'integer', 1),
      result = connectedFields.filter(item => {
        if ($(item[0].parentNode).find('.validationError').text() === ERROR) {
          $(item[0].parentNode).find('.validationError').hide();
          $(item[0]).removeClass('textFiledError');
        }

        return inputsValidator(item[0].value, true, 'integer').isValid;
      }),
      errorElement = $(event.target.parentNode).find('.validationError');

    $(event.target).removeClass('textFiledError');
    if ((event.target.value.length === 0 && result.length === 0) || !ifTargetIsValid.isValid) {
      if (!ifTargetIsValid.isValid) {
        errorElement.text(ifTargetIsValid.errorMessage);
      } else {
        errorElement.text(ERROR);
      }
      errorElement.show();
      $(event.target).addClass('textFiledError');
    } else {
      errorElement.hide();
    }
    this.updateState();
  };

  toggleBlurListeners = addListeners => {
    if (addListeners) {
      let updateState = this.updateState;

      $('input[name="siteId"]').on('blur', event => {
        validateField(event, 'integer', true, updateState, 1);
      });
      $('input[name="pageId"]').on('blur', event => {
        validateField(event, 'integer', true, updateState, 1);
      });
      $('input[name="linearFormatId"]').on(
        'blur',
        (event => {
          this.validateFieldWithOther(event, [$('input[name=nonLinearFormatId]')]);
        }).bind(this)
      );
      $('input[name="nonLinearFormatId"]').on(
        'blur',
        (event => {
          this.validateFieldWithOther(event, [$('input[name=linearFormatId]')]);
        }).bind(this)
      );
      $('input[name="networkId"]').on('blur', event => {
        validateField(event, 'integer', false, updateState, 1);
      });
      $('input[name="targeting"]').on('blur', event => {
        validateField(event, 'string', false, updateState);
      });
      $('input[name="bannerFormatId"]').on('blur', event => {
        validateField(event, 'integer', false, updateState, 1);
      });
      $('input[name="bannerTargeting"]').on('blur', event => {
        validateField(event, 'string', false, updateState);
      });
    } else {
      $('input[name="siteId"]').off('blur');
      $('input[name="pageId"]').off('blur');
      $('input[name="linearFormatId"]').off('blur');
      $('input[name="nonLinearFormatId"]').off('blur');
      $('input[name="networkId"]').off('blur');
      $('input[name="targeting"]').off('blur');
      $('input[name="bannerFormatId"]').off('blur');
      $('input[name="bannerTargeting"]').off('blur');
    }
  };

  render() {
    return (
      <div className="expand-wrapper">
        <div className="placement-wrapper">
          <div
            className="placementDescription"
            onClick={e => this.props.toggleElement(e, '.settingsInputs')}
          >
            <div className="pluginSectionsTitle videoTitle">Video Settings</div>
          </div>
          <div className="settingsInputs">
            <div
              className="settingsDescription description"
              dangerouslySetInnerHTML={{ __html: PD_DESCRIPTION }}
            ></div>
            <div className="inputsRow">
              <div className="labelHolder">
                <div className="smallInput">
                  <label>Site ID</label>
                </div>
                <div className="smallInput">
                  <label>Page ID</label>
                </div>
              </div>
              <div className="smallInput">
                <input
                  type="number"
                  name="siteId"
                  className="textFiled"
                  defaultValue={this.props.data.sas_siteid}
                  key={this.props.data.sas_siteid}
                />
                <div className="validationError"></div>
              </div>
              <div className="smallInput">
                <input
                  type="number"
                  name="pageId"
                  className="textFiled"
                  defaultValue={this.props.data.sas_pageid}
                  key={this.props.data.sas_pageid}
                />
                <div className="validationError"></div>
              </div>
            </div>
            <div className="inputsRow">
              <div className="bigInput">
                <label>Linear format ID </label>
                <input
                  type="number"
                  name="linearFormatId"
                  className="textFiled"
                  defaultValue={this.props.data.sas_format_linears}
                  key={this.props.data.sas_format_linears}
                />
                <div className="validationError"></div>
              </div>
            </div>
            <div className="inputsRow">
              <div className="labelHolder">
                <div className="smallInput">
                  <label>Overlay format ID</label>
                </div>
                <div className="smallInput">
                  <label>Network ID</label>
                </div>
              </div>
              <div className="smallInput">
                <input
                  type="number"
                  name="nonLinearFormatId"
                  className="textFiled"
                  defaultValue={this.props.data.sas_format_overlays}
                  key={this.props.data.sas_format_overlays}
                />
                <div className="validationError"></div>
              </div>
              <div className="smallInput">
                <input
                  type="number"
                  name="networkId"
                  className="textFiled"
                  defaultValue={this.props.data.sas_networkid}
                  key={this.props.data.sas_networkid}
                />
                <div className="validationError"></div>
              </div>
            </div>
            <div className="inputsRow">
              <div className="bigInput">
                <label>Targeting </label>
                <input
                  type="text"
                  name="targeting"
                  className="textFiled"
                  defaultValue={this.props.data.sas_target}
                  key={this.props.data.sas_target}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="divider"></div>
        <div className="placement-wrapper">
          <div
            className="placementDescription"
            onClick={e => this.props.toggleElement(e, '.settingsInputs')}
          >
            <div className="pluginSectionsTitle bannerTitle">Banner Settings (Optional)</div>
          </div>
          <div className="settingsInputs">
            <div
              className="settingsDescription description"
              dangerouslySetInnerHTML={{ __html: PD_BANNER_DESCRIPTION }}
            ></div>
            <div className="inputsRow">
              <div className="labelHolder">
                <div className="smallInput">
                  <label>Display format ID</label>
                </div>
                <div className="smallInput">
                  <label>Display Targeting</label>
                </div>
              </div>
              <div className="smallInput">
                <input
                  type="number"
                  name="bannerFormatId"
                  className="textFiled"
                  defaultValue={this.props.configuration?.banner?.sas_format_banners}
                  key={this.props.configuration?.banner?.sas_format_banners}
                />
                <div className="validationError"></div>
              </div>
              <div className="smallInput">
                <input
                  type="text"
                  name="bannerTargeting"
                  className="textFiled"
                  defaultValue={this.props.configuration?.banner?.sas_target_banners}
                  key={this.props.configuration?.banner?.sas_target_banners}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PlacementData;
